exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-088c6d29]{border-color:#FFFFFF;color:#FFFFFF;min-width:auto;padding:5px 20px;border-width:2px;font-size:14px;margin-top:50px;outline:0}.button[data-v-088c6d29]:hover,.button[data-v-088c6d29]:focus{color:#1396EC;background:#fff;border-color:#fff}@media (max-width: 767px){.button[data-v-088c6d29]{font-size:26px;border:none;margin-left:auto;background:#FF4600}}\n", ""]);

// exports
